import Vue from 'vue';
import firebase from 'firebase/app';
import 'firebase/auth';
// import firebaseui from 'firebaseui';
import 'firebaseui/dist/firebaseui.css';
import { firestorePlugin } from 'vuefire';
import './registerServiceWorker';
import './assets/tailwind.css';
import dayjs from 'dayjs';
import relativeTime from 'dayjs/plugin/relativeTime';
import weekday from 'dayjs/plugin/weekday';
import customParseFormat from 'dayjs/plugin/customParseFormat';
import 'dayjs/locale/de-at';
import currency from 'currency.js';

import App from './App.vue';
import router from './router';
import store from './store';

import { config } from './db';

// eslint-disable-next-line no-var
var app;

Vue.use(firestorePlugin);
dayjs.locale(store.state.format.language);
dayjs.extend(relativeTime);
dayjs.extend(customParseFormat);
dayjs.extend(weekday);


// console.log('Hallo');
// console.log('store', store.state.test);
// console.log('store', store.state.current.value);
Vue.filter('dateFormat', value => {
    if (!value) {
        return '';
    }
    // return moment(value).fromNow(true);
    return dayjs(value).format(store.state.format.date);
});
Vue.filter('dateFormatDM', value => {
    if (!value) {
        return '';
    }
    // return moment(value).fromNow(true);
    return dayjs(value).format(store.state.format.dateDM);
});

const EURO = value => currency(value, {
    negativePattern: '!-#',
    formatWithSymbol: true,
    symbol: '€ ',
    decimal: ',',
    separator: '.',
});
Vue.filter('eur', value => {
    // console.log('money-value:', value);
    if (!value) {
        return 0;
    }

    return EURO(value).format(true);
});
Vue.config.productionTip = false;

if (firebase.apps.length === 0) {
    firebase.initializeApp(config);
    // firebase.firestore().settings({ experimentalForceLongPolling: true });
}
firebase.auth().onAuthStateChanged(() => {
    if (!app) {
        /* eslint-disable no-new */
        app = new Vue({
            el: '#app',
            name: 'App',
            //      template: '<App/>',
            //      components: { App },
            render: h => h(App),
            router,
            store,
        });
        if (window.Cypress) {
            // only available during E2E tests
            window.app = app;
            // console.log('app:', app);
            // window.fbInstance = firebase;
        }
    }
});

// new Vue({
//     router,
//     store,
//     render: h => h(App),
// }).$mount('#app');
